import _ from 'lodash';
import { createSelector } from 'reselect';

export const userSelector = state => _.get(state, 'auth.user');
export const clientSelector = state => _.get(state, 'auth.user.client', {});
export const clientNameSelector = state =>
  _.get(state, 'auth.user.client.name', '');
export const tokenSelector = state => _.get(state, 'auth.token');
export const roleSelector = state => _.get(state, 'auth.user.role', 'user');
export const currentGroupSelector = state =>
  _.get(state, 'auth.currentGroup', null);
export const groupSelector = state => {
  _.get(state, 'auth.user.groups', null);
};

export const isAuthSelector = createSelector(
  userSelector,
  user => !_.isNil(user)
);

export const isRoot = createSelector(roleSelector, role => role === 'root');
export const isAdmin = createSelector(roleSelector, role => role === 'admin');
export const isUser = createSelector(roleSelector, role => role === 'user');

export const isSmarttones = createSelector(
  groupSelector,
  group => group === 'smarttones'
);
export const isPartner = createSelector(
  groupSelector,
  group => group === 'partner'
);
export const isClient = createSelector(
  groupSelector,
  group => group === 'client'
);
export const isStaff = createSelector(
  groupSelector,
  group => group === 'staff'
);
